import { Colors, Lightning, Router } from "@lightningjs/sdk";
import { TranslatableText } from "../components/data-display/TranslatableText/TranslatableText";
import { Button } from "../components/input/Button/Button";
import theme from "../lib/theme";
import { getHomePage } from "../lib/utils";

interface NotFoundPageTemplateSpec extends Lightning.Component.TemplateSpec {
    Box: {
        Text: typeof TranslatableText;
        Button: typeof Button;
    };
}

interface ErrorTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export class NotFoundPage
    extends Lightning.Component<NotFoundPageTemplateSpec, ErrorTypeConfig>
    implements Lightning.Component.ImplementTemplateSpec<NotFoundPageTemplateSpec>
{
    static override _template(): Lightning.Component.Template<NotFoundPageTemplateSpec> {
        return {
            w: theme.layout.w,
            h: theme.layout.h,
            Box: {
                w: 560,
                h: 300,
                mount: 0.5,
                x: (w) => w / 2,
                y: (h) => h / 2,
                flex: { direction: "column", justifyContent: "center", alignItems: "center" },
                texture: Lightning.Tools.getRoundRect(
                    560,
                    300,
                    12,
                    0,
                    undefined,
                    true,
                    Colors(theme.colors.bg.secondary).get()
                ),
                Text: {
                    type: TranslatableText,
                    key: "page.notFound",
                    text: {
                        fontSize: 32,
                        textAlign: "center",
                        wordWrap: true,
                        wordWrapWidth: 500
                    }
                },
                Button: {
                    flexItem: { marginTop: 36 },
                    w: 160,
                    type: Button,
                    label: "general.back"
                }
            }
        };
    }

    override _active() {
        this.application.emit("clearBackground");
    }

    override _getFocused() {
        return this.tag("Box.Button")!;
    }

    override _handleEnter() {
        Router.navigate(getHomePage(), {
            replace: true
        });
    }

    override _handleBack() {
        Router.navigate(getHomePage(), {
            replace: true
        });
    }
}
